import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconMenu = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 18,
	height: 16,
	viewBox: "0 0 18 16",
	fill: "none",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M0 0H18V2H0V0ZM0 7H12V9H0V7ZM0 14H18V16H0V14Z",
		fill: "black"
	})
});
export default SvgIconMenu;
